@if (source$ | async; as source) {
  <ng-container
    [ngTemplateOutlet]="favoriteFilter"
    [ngTemplateOutletContext]="{
      columnFilters: source.columnFilters,
      operatorFilters: source.operatorFilters,
      $implicit: selected,
    }" />
} @else {
  <ng-container
    [ngTemplateOutlet]="favoriteFilter"
    [ngTemplateOutletContext]="{ columnFilters: { items: [] }, operatorFilters: { items: [] }, data: selected }" />
}

<ng-template #favoriteFilter let-columnFilters="columnFilters" let-operatorFilters="operatorFilters" let-selected>
  <div class="search" [attr.data-cy-ufilter-tablename]="tableName">
    <iu-prime-chips
      class="prime-chips-toolbar"
      data-cy="universal-filter-chips"
      [buildItemOnSave]="buildChipsOnSave"
      [conditionToAdd]="conditionToAdd"
      [hasScroll]="hasScroll"
      [widthChipsContainer]="widthChipsContainer"
      [(ngModel)]="filterChips"
      (addError)="onAddError()"
      (onAdd)="addFilterByChips($event.originalEvent, $event.value)"
      (onRemove)="removeFilterByChips($event.originalEvent, $event.value)">
      <ng-template let-item pTemplate="item">
        @if (item) {
          <span style="margin-right: 3px" [attr.data-cy-chips-columnName]="item?.columnName" class="{{ item?.icon }}">
          </span>
        }
        {{ item?.displayValue }}
      </ng-template>
    </iu-prime-chips>

    <span [ngClass]="[isDisplayGroupFilter ? 'opened' : '', 'group']">
      <button
        #buttonGroupFilter
        class="p-menu-bar-button group"
        data-cy="universal-filter-setting"
        icon="icon-advanced-search-2"
        pButton
        tooltipPosition="top"
        type="button"
        [hideDelay]="250"
        [life]="3000"
        pTooltip="{{ 'universalFilter.filter' | translate }}"
        [showDelay]="250"
        (click)="updatePanelFilter($event, 'GroupFilter', 'group-filter-panel')"></button>
      <iu-prime-overlay #overlayFilter [appendTo]="'body'" [dismissable]="false">
        @if (isDisplayGroupFilter) {
          <div id="group-filter-panel" class="iu-universal-filter-standalone group-list ui-overlaypanel {{ isMobile ? 'mobile' : '' }}">
            @if (selected.filters.length > 0) {
              <div class="uf-section-header" [ngStyle]="{ order: 0 }">
                <span class="uf-section-title">{{ 'universalFilter.filterTitle' | translate }}</span>
                <span class="uf-section-count">{{ selected.filters.length }}</span>
              </div>
              <div class="uf-columns-header" aria-hidden="true" [ngStyle]="{ order: 0 }">
                <span class="uf-col-grab"></span>
                <span class="uf-col-fields">
                  <span class="uf-col lev-1">{{ 'universalFilter.columnHeader' | translate }}</span>
                  <span class="uf-col lev-2">{{ 'universalFilter.operatorHeader' | translate }}</span>
                  <span class="uf-col lev-3">{{ 'universalFilter.valueHeader' | translate }}</span>
                </span>
                <span class="uf-col-del"></span>
              </div>
              <ul
                #filtersContainer
                cdkDropList
                data-uf="filters"
                [ngStyle]="{ order: 0 }"
                (cdkDropListDropped)="moveItem($event, 'filters')">
                @for (
                  filter of selected.filters;
                  track filter.column.id;
                  let isFirst = $first;
                  let isLast = $last;
                  let i = $index
                ) {
                  <div cdkDrag data-cy="universal-filter-line" [attr.data-cy-index]="i">
                    <div *cdkDragPreview class="ui-row-drag-preview">
                      <!-- Preview du drag -->{{ 'universalFilter.filterPreview' | translate
                      }}{{ filter.column.displayValue || '[ColumnName]' }}
                      {{ filter.operator.displayValue || '[Operator]' }}
                      {{ filter.filter || '[Filter]' }}
                      {{
                        filter.filterTo !== undefined && filter.filterTo !== null && filter.filterTo !== ''
                          ? ' - ' + filter.filterTo
                          : ''
                      }}
                    </div>
                    <div *cdkDragPlaceholder class="ui-row-drag-placeholder"><!-- Placeholder du drag --></div>
                    <li class="ui-row" [attr.data-cy-row]="filter.column.id">
                      <span cdkDragHandle class="icon-grab" style="font-size: 17px; cursor: move" [title]="'universalFilter.dragToReorder' | translate"></span>
                      <div class="filtres">
                        <div
                          data-cy="universal-filter-column-autocomplete"
                          class="lev-1 filter-field {{ filter?.column?.id === -1 ? 'valueEmpty' : '' }}">
                          <iu-autocomplete-ui
                            [data]="
                              columnFilters
                                | universalFilterColFilterType: 0 : i : CompiereDataGridFilterType.NONE
                                | autocompleteSuggestionsFilter: usedFilterColumnNames : filter.column.id
                            "
                            [fieldValue]="filter.column"
                            [isInUniversalFilter]="true"
                            [isInsideOverflow]="true"
                            [isStandalone]="true"
                            (fieldValueModified)="setColumnFilter($any($event), i)" />
                        </div>

                        <div
                          data-cy="universal-filter-operator-autocomplete"
                          class="lev-2 filter-field {{ filter?.column?.id === -1 ? 'valueEmpty' : '' }}">
                          <iu-autocomplete-ui
                            [data]="operatorFilters | operatorFilter: filter?.column?.columnInfo?.filterType"
                            [fieldValue]="filter.operator"
                            [isInUniversalFilter]="true"
                            [isInsideOverflow]="true"
                            [isStandalone]="true"
                            (fieldValueModified)="setOperatorFilter($any($event), i)" />
                        </div>

                        <div
                          data-cy="universal-filter-value"
                          class="lev-3 filter-field {{ filter?.operator?.operator?.isRange ? 'isRange' : '' }}">
                          <ng-template #vcrFilter />
                        </div>
                        <div
                          data-cy="universal-filter-value-to"
                          class="lev-4 filter-field {{ filter?.operator?.operator?.isRange ? 'isRange' : '' }}">
                          @if (filter?.operator?.operator?.isRange) {
                            @switch (filter?.column?.columnInfo?.filterType) {
                              @case ('text') {
                                <iu-input-text-ui
                                  [fieldValue]="filter.filterTo"
                                  [isInUniversalFilter]="true"
                                  [isStandalone]="true"
                                  (fieldValueModified)="setFilterTo($event, $index)" />
                              }
                              @case ('number') {
                                <iu-input-number-ui
                                  [fieldValue]="filter.filterTo"
                                  [isInUniversalFilter]="true"
                                  [isStandalone]="true"
                                  (fieldValueModified)="setFilterTo($event, i)" />
                              }
                              @case ('date') {
                                <iu-calendar-ui
                                  [calendarConfig]="filter.configsTo?.calendarConfig || { todayMode: false }"
                                  [data]="{
                                    needTime: filter.column.columnInfo.fieldEntity.field.AD_Reference_ID === 16,
                                  }"
                                  [fieldValue]="
                                    filter.filterTo
                                      | toDate: filter.column.columnInfo.fieldEntity.field.AD_Reference_ID === 16
                                  "
                                  [hasTodayBtn]="true"
                                  [isInUniversalFilter]="true"
                                  [isStandalone]="true"
                                  (calendarConfigChange)="onCalendarConfigChange($event, i, true)"
                                  (fieldValueModified)="setFilterTo($event, i)" />
                              }
                              @case ('time') {
                                <iu-input-time-ui
                                  [calendarConfig]="filter.configsTo?.calendarConfig || { todayMode: false }"
                                  [fieldValue]="filter.filterTo | toDate: true"
                                  [isInUniversalFilter]="true"
                                  [isStandalone]="true"
                                  (calendarConfigChange)="onCalendarConfigChange($event, i, true)"
                                  (fieldValueModified)="setFilterTo($event, i)" />
                              }
                            }
                          }
                        </div>
                      </div>
                      <div class="delete" data-cy="universal-filter-remove-filter">
                        <button
                          class="hover uf-remove-btn"
                          icon="icon-delete"
                          pButton
                          tooltipPosition="top"
                          [attr.aria-label]="'generic.delete' | translate"
                          [hideDelay]="250"
                          [life]="3000"
                          pTooltip="{{ 'generic.delete' | translate }}"
                          [showDelay]="250"
                          (click)="removeFilter(i, $event)"></button>
                      </div>
                    </li>
                  </div>
                }
              </ul>
              <ul class="buttonAdd" [ngStyle]="{ order: 0 }">
                <li class="ui-row">
                  <div class="p-col-12">
                    <!-- au clic créaction d'un nouvel Li au-dessus de celui-ci et contenant un pemier auto-complete-->
                    @if (canFilter) {
                      <button
                        class="button p-button-secondary uf-add-btn"
                        data-cy="universal-filter-add-filter-one"
                        icon="icon-add"
                        id="addrow"
                        pButton
                        style="cursor: pointer"
                        type="button"
                        label="{{ 'universalFilter.addFilter' | translate }}"
                        (click)="addFilter($event)"></button>
                    }
                  </div>
                </li>
              </ul>
            }

            @if (selected.groups.length > 0) {
              <div class="uf-section-header" [ngStyle]="{ order: 1 }">
                <span class="uf-section-title">{{ 'universalFilter.groupTitle' | translate }}</span>
                <span class="uf-section-count">{{ selected.groups.length }}</span>
              </div>

              <!-- one compact line per level: grab | level | column | remove -->
              <ul
                #groupsContainer
                cdkDropList
                class="uf-groups"
                data-uf="groups"
                [ngStyle]="{ order: 1 }"
                (cdkDropListDropped)="moveItem($event, 'groups')">
                @for (
                  group of selected.groups;
                  track group.id;
                  let isFirst = $first;
                  let isLast = $last;
                  let i = $index
                ) {
                  <div cdkDrag data-cy="universal-filter-group" [attr.data-cy-index]="i">
                    <div *cdkDragPreview class="ui-row-drag-preview">
                      <!-- Preview du drag -->{{ 'universalFilter.groupPreview' | translate
                      }}{{ group.displayValue || '[ColumnName]' }}
                    </div>
                    <div *cdkDragPlaceholder class="ui-row-drag-placeholder"><!-- Placeholder du drag --></div>
                    <li class="ui-row uf-group-row">
                      <span
                        cdkDragHandle
                        class="icon-grab"
                        [title]="'universalFilter.dragToReorder' | translate"></span>
                      <span class="uf-group-level" aria-hidden="true">{{ i + 1 }}</span>
                      <div class="lev-1 filter-field" data-cy="universal-filter-group-autocomplete">
                        <iu-autocomplete-ui
                          [data]="columnFilters | columnGroupFilter"
                          [fieldValue]="group"
                          [isInUniversalFilter]="true"
                          [isInsideOverflow]="true"
                          [isStandalone]="true"
                          (fieldValueModified)="setGroup($any($event), i)" />
                      </div>
                      <div class="delete" data-cy="universal-filter-remove-group">
                        <button
                          class="hover uf-remove-btn"
                          icon="icon-delete"
                          pButton
                          tooltipPosition="top"
                          type="button"
                          [attr.aria-label]="'generic.delete' | translate"
                          [hideDelay]="250"
                          [life]="3000"
                          pTooltip="{{ 'generic.delete' | translate }}"
                          [showDelay]="250"
                          (click)="removeGroup(i, $event)"></button>
                      </div>
                    </li>
                  </div>
                }
              </ul>

              <ul class="buttonAdd uf-groups-add" [ngStyle]="{ order: 1 }">
                <li class="ui-row">
                  @if (canGroup) {
                    <button
                      class="uf-add-link"
                      data-cy="universal-filter-add-group-one"
                      type="button"
                      (click)="addGroup($event)">
                      <span class="icon-add" aria-hidden="true"></span>{{ 'universalFilter.addGroup' | translate }}
                    </button>
                  }
                </li>
              </ul>
            }

            @if (selected.sortings.length > 0) {
              <div class="uf-section-header" [ngStyle]="{ order: 2 }">
                <span class="uf-section-title">{{ 'universalFilter.sortingTitle' | translate }}</span>
                <span class="uf-section-count">{{ selected.sortings.length }}</span>
              </div>

              <ul
                #sortsContainer
                cdkDropList
                data-uf="sortings"
                [ngStyle]="{ order: 2 }"
                (cdkDropListDropped)="moveItem($event, 'sortings')">
                @for (
                  sorting of selected.sortings;
                  track sorting.column.id;
                  let isFirst = $first;
                  let isLast = $last;
                  let i = $index
                ) {
                  <div cdkDrag data-cy="universal-filter-sort" [attr.data-cy-index]="i">
                    <div *cdkDragPreview class="ui-row-drag-preview">
                      <!-- Preview du drag -->{{ 'universalFilter.sortingPreview' | translate
                      }}{{ sorting.column.displayValue || '[ColumnName]' }} {{ sorting.sortingType }}
                    </div>
                    <div *cdkDragPlaceholder class="ui-row-drag-placeholder"><!-- Placeholder du drag --></div>
                    <li class="ui-row">
                      <div class="filtres">
                        <span cdkDragHandle class="icon-grab" style="font-size: 17px; cursor: move" [title]="'universalFilter.dragToReorder' | translate"></span>
                        <div class="lev-1 filter-field" data-cy="universal-filter-sort-autocomplete">
                          <iu-autocomplete-ui
                            [data]="columnFilters"
                            [disable]="true"
                            [fieldValue]="sorting.column"
                            [isInUniversalFilter]="true"
                            [isInsideOverflow]="true"
                            [isStandalone]="true"
                            (fieldValueModified)="setSorting($any($event), i)" />
                        </div>
                        <li class="asc-desc filter-field">
                          <div class="p-col-2 asc">
                            <input
                              data-cy="universal-filter-sort-type-asc"
                              label="asc"
                              type="radio"
                              value="asc"
                              checked="{{ sorting.sortingType === 'asc' ? 'checked' : null }}"
                              id="uf-sort-{{ i }}-asc"
                              name="sorting_{{ i }}"
                              [(ngModel)]="sorting.sortingType" /><label id="asc" for="uf-sort-{{ i }}-asc">{{ 'grid.sort.asc' | translate }}</label>
                          </div>
                          <div class="p-col-2 desc">
                            <input
                              data-cy="universal-filter-sort-type-desc"
                              label="desc"
                              type="radio"
                              value="desc"
                              checked="{{ sorting.sortingType === 'desc' ? 'checked' : null }}"
                              id="uf-sort-{{ i }}-desc"
                              name="sorting_{{ i }}"
                              [(ngModel)]="sorting.sortingType" /><label id="desc" for="uf-sort-{{ i }}-desc">{{ 'grid.sort.desc' | translate }}</label>
                          </div>
                        </li>
                        <div class="delete" data-cy="universal-filter-remove-sort">
                          <button
                            class="hover uf-remove-btn"
                            icon="icon-delete"
                            pButton
                            tooltipPosition="top"
                            [attr.aria-label]="'generic.delete' | translate"
                            [hideDelay]="250"
                            [life]="3000"
                            pTooltip="{{ 'generic.delete' | translate }}"
                            [showDelay]="250"
                            (click)="removeSorting(i, $event)"></button>
                        </div>
                      </div>
                    </li>
                  </div>
                }
              </ul>

              <ul class="buttonAdd" [ngStyle]="{ order: 2 }">
                <li class="ui-row">
                  <div class="p-col-12">
                    <!-- au clic créaction d'un nouvel Li au-dessus de celui-ci et contenant un pemier auto-complete-->
                    @if (canSort) {
                      <button
                        class="button p-button-secondary uf-add-btn"
                        data-cy="universal-filter-add-sort-one"
                        icon="icon-add"
                        pButton
                        style="cursor: pointer"
                        type="button"
                        label="{{ 'universalFilter.addSorting' | translate }}"
                        (click)="addSorting($event)"></button>
                    }
                  </div>
                </li>
              </ul>
            }
            <div class="actions ui-row">
              <div class="action">
                @if (canFilter && selected.filters.length <= 0) {
                  <button
                    class="button p-button-secondary p-button action-btn uf-add-btn"
                    type="button"
                    data-cy="universal-filter-add-filter-none"
                    style="cursor: pointer"
                    (click)="addFilter($event)">
                    <span class="icon-add"></span>{{ 'universalFilter.addFilter' | translate }}
                  </button>
                }
                @if (canGroup && selected.groups.length <= 0) {
                  <button
                    class="button p-button-secondary p-button action-btn uf-add-btn"
                    type="button"
                    data-cy="universal-filter-add-group-none"
                    style="cursor: pointer"
                    (click)="addGroup($event)">
                    <span class="icon-add"></span>{{ 'universalFilter.addGroup' | translate }}
                  </button>
                }
                @if (canSort && selected.sortings.length <= 0) {
                  <button
                    class="button p-button-secondary p-button action-btn uf-add-btn"
                    type="button"
                    data-cy="universal-filter-add-sort-none"
                    style="cursor: pointer"
                    (click)="addSorting($event)">
                    <span class="icon-add"></span>{{ 'universalFilter.addSorting' | translate }}
                  </button>
                }
              </div>
              <div class="action right">
                <button
                  class="p-button p-button-primary"
                  data-cy="apply-filter-btn"
                  pButton
                  type="button"
                  label="{{ 'generic.apply' | translate }}"
                  (click)="applyFilter($event)"></button>
                <button
                  class="p-button p-button-secondary"
                  data-cy="reset-filter-btn"
                  pButton
                  type="button"
                  label="{{ 'universalFilter.resetFilters' | translate }}"
                  (click)="resetFilters($event)"></button>
              </div>
            </div>
          </div>
        }
      </iu-prime-overlay>
    </span>
  </div>
</ng-template>
